import { Injectable, Inject } from '@angular/core';
import { WindowRef } from '@agm/core/utils/browser-globals';
import { environment } from '../../../environments/environment';

@Injectable()
export class AgmmapProviderService  {

    apiKey: string;
    libraries: string[];

    constructor(private window: WindowRef) {
        this.libraries = ['places'];
        const settings = this.window.getNativeWindow()._WFSDirect_Object;
        if (settings !== undefined && settings !== null && settings !== '') {
            if (settings.googleMapsKey !== undefined && settings.googleMapsKey !== null && settings.googleMapsKey !== '') {
                this.apiKey = settings.googleMapsKey;
                return;
            }
        }
        this.apiKey = environment.MAPS_API_KEY;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/providers/agmmap-provider.service.ts